// app-initializer.ts
import { ZTicketVaultDb } from './zticketvault-document.model';
import { APP_INITIALIZER, Provider } from '@angular/core';

export const TICKET_VAULT_DB = new ZTicketVaultDb();

export function initDatabase_ZTicketVaultDb() {
  return async () => {
    await TICKET_VAULT_DB.open();
    console.log('[Vault] IndexedDB ready');
  };
}

export const TICKET_VAULT_PROVIDERS: Provider[] = [
  { provide: APP_INITIALIZER, useFactory: initDatabase_ZTicketVaultDb, multi: true },
  { provide: ZTicketVaultDb, useValue: TICKET_VAULT_DB }
];